import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import {
  EditDirectionD,
  fetchAllData,
} from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function DirectionEdit({
  directionEdit,
  directionId,
  setDirectionEdit,
}) {
  const data = useSelector(
    (state) => state.main.data?.instructionsData
  )?.filter((item) => item.id == directionId)?.[0];
  const [mainPhoto, setMainPhoto] = useState(``);
  const [photoFile, setPhotoFile] = useState();
  const [mainPhoto2, setMainPhoto2] = useState(``);
  const [photoFile2, setPhotoFile2] = useState();
  const [name, setName] = useState(``);
  const [directions, setDirections] = useState(``);
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setPhotoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleFile2Change = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto2(reader.result);
    };
    setPhotoFile2(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const EditDirection = () => {
    dispatch(
      EditDirectionD({ name, directions, photoFile, photoFile2, directionId })
    );

    setMainPhoto("");
    setMainPhoto2("");
    setPhotoFile("");
    setPhotoFile2("");
    setName("");
    toast.info("Editing Direction...", { autoClose: false });
    setDirectionEdit(false);
  };
  return (
    directionEdit && (
      <div className="direction-edit-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setDirectionEdit(false)}
        ></div>
        <div className="container ">
          <div className="title">تعديل تعليمات </div>
          <div className="group">
            {" "}
            <div className="image">
              <label htmlFor="add-image">
                <div className="title">الصور الاساسيه</div>
                <img
                  className={mainPhoto ? `` : ` none`}
                  src={
                    mainPhoto
                      ? `${mainPhoto}`
                      : `https://api.atharalfarasha.com/public/hakim/${data?.instruction_photo}`
                  }
                  alt=""
                />
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                name=""
                accept="image/*"
                id="add-image"
                style={{ display: "none" }}
              />
            </div>
            <div className="image">
              <label htmlFor="add-image2">
                <div className="title">الصور الثانيه</div>
                <img
                  className={mainPhoto2 ? `` : ` none`}
                  src={
                    mainPhoto2
                      ? `${mainPhoto2}`
                      : `https://api.atharalfarasha.com/public/hakim/${data?.instructions_photo_2}`
                  }
                  alt=""
                />
              </label>
              <input
                type="file"
                onChange={handleFile2Change}
                name=""
                accept="image/*"
                id="add-image2"
                style={{ display: "none" }}
              />
            </div>
          </div>
          <div className="text">
            <input
              type="text"
              placeholder="Name"
              defaultValue={data?.instruction_name}
              onChange={(e) => setName(e.target.value)}
            />
            <textarea
              type="text"
              placeholder="Directions"
              defaultValue={data?.instruction_text}
              onChange={(e) => setDirections(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => EditDirection()}>
            تعديل
          </div>
        </div>
      </div>
    )
  );
}
